<template>
  <!-- 应收款明细表 -->
<div class="ti d-flex">
  <div class="d-flex-left">
    <erp-tree @node-click="nodeClick"></erp-tree>
  </div>
  <div class="d-flex-right">
    <!-- 设置 -->
    <div v-if="seup == 2" style="width: 99.8%;">
      <div style="margin-bottom: 5px;">
         <el-button @click="postAdd">保存</el-button>
         <el-button @click="tup">返回</el-button>
      </div>
      <div class="cdj_div">仪表编号（{{setup_list.number}}）收费标准设置</div>
      <div class="cdj_table">
        <div class="cdj_display">
          <div class="cdj_left">
            <div class="cdj_left_display">
              <div class="cdj_left_display_background">仪表名称</div>
              <div class="cdj_el-input">
                <el-input  placeholder="" v-model="setup_list.dummy_meter_name" clearable disabled></el-input>
              </div>
            </div>
            <div class="cdj_left_display cdj_top">
              <div class="cdj_left_display_background">仪表所在房产</div>
              <div class="cdj_el-input">
                <el-input  placeholder="" v-model="setup_list.HouseName" clearable disabled></el-input>
              </div>
            </div>
            <div class="cdj_left_display cdj_top">
              <div class="cdj_left_display_background">附件</div>
              <div class="cdj_el-input">

              </div>
            </div>
            <div class="cdj_left_display cdj_top">
              <div class="cdj_left_display_background">空置房收费对象</div>
              <div class="cdj_el-input" style="display: flex;">
                <el-input  placeholder="" v-model="developer.name" clearable></el-input>
                <el-button style="margin-left: 3px;" @click="updatesc">选择</el-button>
              </div>
            </div>
          </div>
          <div class="cdj_left">
            <div class="cdj_left_display">
              <div class="cdj_left_display_background">收费标准</div>
              <div class="cdj_el-input">
                <el-input  placeholder="" v-model="setup_list.cname" clearable disabled></el-input>
              </div>
            </div>
            <div class="cdj_left_display cdj_top">
              <div class="cdj_left_display_background">费用单价</div>
              <div class="cdj_el-input el-date-pickers">
                <el-input placeholder="" v-model="setup_list.charge" clearable disabled></el-input>
              </div>
            </div>
            <div class="cdj_left_display cdj_top">
              <div class="cdj_left_display_background">默认收费对象</div>
              <div class="cdj_el-input el-date-pickers" style="margin-top: 7px;">
                <el-radio v-model="name_type" label="1">业主</el-radio>
                <el-radio style="margin-left: -10px;" v-model="name_type" label="2">租户</el-radio>
                <span style="margin-left: 5px;color:red;">(指从左侧选择房产时，默认的收费对象类型)</span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 分摊组件 -->
       <el-tabs v-model="activeName" @tab-click="handleClick"  style="margin-top: 1px;">
        <el-tab-pane label="通用分摊" name="currency">
          <share-currency ref="currency_child" :house="house" :activeName="activeName" :setup_list="setup_list"></share-currency>
        </el-tab-pane>
        <el-tab-pane label="平均分摊" name="average">
          <share-average ref="average_child" :house="house" :activeName="activeName" :setup_list="setup_list"></share-average>
        </el-tab-pane>
        <el-tab-pane ref="child" label="面积分摊" name="area">
          <share-area ref="area_child" :house="house" :activeName="activeName" :setup_list="setup_list"></share-area>
        </el-tab-pane>
        <el-tab-pane label="用量分摊" name="consumption">
          <share-consumption ref="consumption_child" :house="house" :activeName="activeName" :setup_list="setup_list"></share-consumption>
        </el-tab-pane>
        <el-tab-pane label="楼层分摊" name="floor">
          <share-floor ref="floor_child" :house="house" :activeName="activeName" :setup_list="setup_list"></share-floor>
        </el-tab-pane>
      </el-tabs>
    </div>
    <!-- 列表 -->
    <div v-if="seup == 1">
        <div style="margin-bottom: 5px;">
           <el-button @click="searchs">搜索</el-button>
           <!-- <el-button @click="del">清除</el-button> -->
         </div>
         <div class="cdj_div">查询条件</div>
         <div class="cdj_table">
           <div class="cdj_display">
             <div class="cdj_left">
               <div class="cdj_left_display">
                 <div class="cdj_left_display_background">仪表类型</div>
                 <div class="cdj_el-input">
                   <el-select
                       v-model="data.meter_type_id"
                       style="width: 100%"
                       size="mini"
                       clearable
                       @change="chargeitem_types"
                       placeholder="仪表类型">
                       <el-option
                         v-for="item in meter_type"
                         :key="item.id"
                         :label="item.name"
                         :value="item.id">
                       </el-option>
                     </el-select>
                 </div>
               </div>
               <div class="cdj_left_display cdj_top">
                 <div class="cdj_left_display_background">仪表编号</div>
                 <div class="cdj_el-input">
                    <el-input size="mini" placeholder="仪表编号" v-model="data.number" clearable></el-input>
                 </div>
               </div>
               <div class="cdj_left_display cdj_top">
                 <div class="cdj_left_display_background">仪表名称</div>
                 <div class="cdj_el-input">
                   <el-input size="mini" placeholder="仪表名称" v-model="data.name" clearable></el-input>
                 </div>
               </div>
             </div>
             <div class="cdj_left">
               <div class="cdj_left_display">
                 <div class="cdj_left_display_background">当前房产</div>
                 <el-select
                     v-model="data.homeName"
                     class="cdj_el-input"
                     size="mini"
                     filterable
                     remote
                     clearable
                     reserve-keyword
                     placeholder="可搜索房产/客户姓名"
                     :remote-method="remoteMethod"
                     :loading="loading">
                     <el-option
                       v-for="item in selectList"
                       :key="item.id"
                       :label="item.house"
                       :value="item.house">
                     </el-option>
                   </el-select>
               </div>
               <div class="cdj_left_display cdj_top">
                 <div class="cdj_left_display_background">收费标准</div>
                 <div class="cdj_el-input el-date-pickers">
                   <el-select
                       v-model="data.chargeitem_type_id"
                       style="width: 100%"
                       clearable
                       size="mini"
                       placeholder="收费标准">
                       <el-option
                         v-for="item in chargeitem_type"
                         :key="item.id"
                         :label="item.name"
                         :value="item.id">
                       </el-option>
                     </el-select>
                 </div>
               </div>
               <div class="cdj_left_display cdj_top">
                 <div class="cdj_left_display_background">设置情况</div>
                 <div class="cdj_el-input el-date-pickers" style="margin-top: 3px;">
                   <el-checkbox-group v-model="data.status">
                      <el-checkbox label="1" name="type">未设置</el-checkbox>
                      <el-checkbox label="2" name="type">已设置</el-checkbox>
                    </el-checkbox-group>
                 </div>
               </div>
             </div>
           </div>
         </div>
         <div style="margin-top: 5px;"></div>
         <el-table ref="multipleTable" :data="desserts" border tooltip-effect="dark" style="width: 100%" height="47vh" @selection-change="handleSelectionChange">
           <el-table-column type="selection" width="55"></el-table-column>
           <el-table-column prop="id" label="ID" width="80"></el-table-column>
           <el-table-column prop="tname" label="仪表类型" width="200"></el-table-column>
           <el-table-column prop="dummy_meter_id" label="仪表编号" width="130"></el-table-column>
           <el-table-column prop="dummy_meter_name" label="仪表名称" width="130"></el-table-column>
           <el-table-column prop="cname" label="仪表标准" width="200"></el-table-column>
           <el-table-column prop="setup" label="设置" width="130"></el-table-column>
           <el-table-column prop="HouseName" label="所在房产" show-overflow-tooltip></el-table-column>
           <el-table-column label="操作" width="80">
             <template slot-scope="scope">
               <div style="display: flex;">
                 <div style="color:blue;cursor: pointer;" @click="setups(scope.row)">设置</div>
               </div>
             </template>
           </el-table-column>
         </el-table>
         <div class="pages" v-if="desserts">
           <Page :total="total" :page-size="page" @on-change="change"  show-total />
         </div>
         <div class="zhanwu" v-else>没有数据</div>
       </div>
    </div>

    <!-- 弹窗选择用户 -->
    <Modal
      v-model="modal1"
      width="800"
      title="选择客户"
      @on-ok="roomUser">
      <div>
        <room-user style="height: 600px;" ref="child" :house="house"></room-user>
      </div>
    </Modal>
</div>

</template>

<script>
import imgurl from "../../../../assets/js/imgurl.js";
export default {
  name: "FormsOweMoney",
  data () {
    return {
      activeName:'currency',
      modal1:false,
      seup:1,
      checkeds:'',
      checked:[],
      checked_list:[],
      selectList:[],
      checked_up:[],
      project_id:'',
      radio:'1',
      startDate:'',
      endDate:'',
      meter_type:[],
      chargePercentage:'',
      chargePercentage1:'',
      buttonSize:'1',
      money:'--',
      loading:false,
      desserts: '',
      total:0,
      page:12,
      search:'',
      state:0,
      chargeitem_list:[],
      data:{
        pid:'',
        house_id:'',
        number:'',
        name:'',
        homeName:'',
        status:[],
        meter_type_id:'',
        chargeItem_name_id:'',
      },
      chargeitem_type:[],
      chargeitem_1:[],
      charge:[],
      data_list:[],
      homeName:'',
      type:'',//1批量设置、2修改保存、3全部修改
      developer:[],
      house:'',
      setup_list:{},
      name_type:"1",
    }
  },
  //界面没出来前加载
  created() {
  },
  // 加载数据
  mounted(){
    this.change(1);
    //加载仪表类型
    this.$myhttp.get('admin/ShareSetup/meter_type',{
      'Content-Type': 'application/json'
      }).then(backdata=>{
        this.meter_type = backdata.data.data;
    });
    this.$myhttp.get('admin/RoomSetUp/getChargeitem_type',{
      'Content-Type': 'application/json'
      }).then(backdata=>{
        this.chargeitem_list = backdata.data.data;
    });
  },
  computed:{
    __TABLE_HEIGHT__(){
      return ERP.getStore().__TABLE_HEIGHT__
    }
  },
  //事件
  methods: {
    tup(){
      this.seup = 1;
    },
    //点击设置
    setups(item){
      //console.log(item)
      this.$myhttp.get("admin/ShareSetup/shareId?id="+item.id,{
        'Content-Type': 'application/json'
        }).then(backdata=>{
        if(backdata.data.code == 200){
          if(backdata.data.type == 1){
            this.$refs.currency_child.datas(backdata.data.data)
          }
          if(backdata.data.type == 2){
            this.$refs.average_child.datas(backdata.data.data)
          }
          if(backdata.data.type == 3){
            this.$refs.area_child.datas(backdata.data.data)
          }
          if(backdata.data.type == 4){
             this.$refs.consumption_child.datas(backdata.data.data)
          }
          if(backdata.data.type == 5){
            this.$refs.floor_child.datas(backdata.data.data)
          }
        }
      });
      this.setup_list = item;
      this.setup_list.name_type = this.name_type;
      this.seup = 2;
    },
    //切换组件
    handleClick(){
      //console.log(this.activeName)
    },
    //选择客户
    updatesc(){
      this.modal1 = true;
    },
    //选择客户
    roomUser(){
      this.developer = this.$refs.child.getUser();
    },
    //点击仪表类型
    chargeitem_types(){
      this.$myhttp.get("admin/ShareSetup/charge?id="+this.data.meter_type_id+'&pid='+this.data.pid,{
        'Content-Type': 'application/json'
        }).then(backdata=>{
          this.chargeitem_type = backdata.data.data;
      });
    },
    //选择收费标准
    charges(id,index){
      let checked = this.chargeitem_list[index].checked;
      checked.map(req=>{
        if(req.id == id){
          this.chargeitem_list[index].price = req.charge;
        }
      })
    },
    //保存
    postAdd(){
      let data = [];
      if(this.activeName == 'currency'){
        data = this.$refs.currency_child.getUser()
      }
      if(this.activeName == 'average'){
        data = this.$refs.average_child.getUser()
      }
      if(this.activeName == 'area'){
        data = this.$refs.area_child.getUser()
      }
      if(this.activeName == 'consumption'){
        data = this.$refs.consumption_child.getUser()
      }
      if(this.activeName == 'floor'){
        data = this.$refs.floor_child.getUser()
      }
      let post = {'type':this.activeName,'data':data,'setup_list':this.setup_list}
      this.$myhttp.post('admin/ShareSetup/post',post,{
        'Content-Type': 'application/x-www-form-urlencoded'
        }).then(backdata=>{ // 异步执行成功后
           if(backdata.data.code == 200){
             this.seup = 1;
             this.change(1);
             this.$Message.success('操作成功!');
           }else{
             this.$Message.error(backdata.data.message);
           }
      });
      //console.log(data);
    },
    //删除
    del(){
      this.$confirm('确定要删除吗, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$myhttp.post('admin/RoomSetUp/del',this.checked,{
            'Content-Type': 'application/x-www-form-urlencoded'
            }).then(backdata=>{ // 异步执行成功后
               if(backdata.data.code == 200){
                 this.change(1);
                 this.$Message.success('操作成功!');
               }else{
                 this.$Message.error(backdata.data.message);
               }
          });
        }).catch(() => {

        });
    },
    //全选
    // checkeds_list(){
    //   console.log(this.checkeds)
    //   if(this.checkeds == true){
    //     this.checked={
    //       checked0:this.desserts[0].id,
    //       checked1:this.desserts[1].id,
    //       checked2:this.desserts[2].id,
    //       checked3:this.desserts[3].id,
    //       checked4:this.desserts[4].id,
    //       checked5:this.desserts[5].id,
    //       checked6:this.desserts[6].id,
    //       checked7:this.desserts[7].id,
    //       checked8:this.desserts[8].id,
    //       checked9:this.desserts[9].id,
    //       checked10:this.desserts[10].id,
    //       checked11:this.desserts[11].id,
    //     }
    //   }else{
    //     this.checked={
    //       checked0:"",
    //       checked1:"",
    //       checked2:"",
    //       checked3:"",
    //       checked4:"",
    //       checked5:"",
    //       checked6:"",
    //       checked7:"",
    //       checked8:"",
    //       checked9:"",
    //       checked10:"",
    //       checked11:"",
    //     }
    //   }
    // },
    handleSelectionChange(val) {
      this.checked={
        checked0:"",
        checked1:"",
        checked2:"",
        checked3:"",
        checked4:"",
        checked5:"",
        checked6:"",
        checked7:"",
        checked8:"",
        checked9:"",
        checked10:"",
        checked11:"",
      };
      let order = val;
      order.map((req,index)=>{
        if(index == 0){
          this.checked.checked0 = req.id;
        }
        if(index == 1){
          this.checked.checked1 = req.id;
        }
        if(index == 2){
          this.checked.checked2 = req.id;
        }
        if(index == 3){
          this.checked.checked3 = req.id;
        }
        if(index == 4){
          this.checked.checked4 = req.id;
        }
        if(index == 5){
          this.checked.checked5 = req.id;
        }
        if(index == 6){
          this.checked.checked6 = req.id;
        }
        if(index == 7){
          this.checked.checked7 = req.id;
        }
        if(index == 8){
          this.checked.checked8 = req.id;
        }
        if(index == 9){
          this.checked.checked9 = req.id;
        }
        if(index == 10){
          this.checked.checked10 = req.id;
        }
        if(index == 11){
          this.checked.checked11 = req.id;
        }
      })
    },
    remoteMethod(query){
      if (query !== '') {
        // console.log(query);
        this.loading = true;
        this.$myhttp.get('admin/common/house_text?text='+query+'&project_id='+this.project_id,{
          'Content-Type': 'application/json'
          }).then(backdata=>{ // 异步执行成功后
            this.selectList = backdata.data.data;
            this.loading = false;
        });
      } else {
        this.selectList = [];
      }
    },
    //获得当前多少页,分页
    change(e){
      this.dates();
      //ERP.showLoading()
      this.data.page = e;
      this.$myhttp.post('admin/ShareSetup/share_setup_list',this.data,{
        'Content-Type': 'application/x-www-form-urlencoded'
        }).then(backdata=>{ // 异步执行成功后
          let data = backdata.data.data;
          this.desserts = data.data;
          this.total = data.count;
          this.page = data.pageSize;
          //ERP.hideLoading()
      });
      this.checkeds = false;
      this.checked={
        checked0:"",
        checked1:"",
        checked2:"",
        checked3:"",
        checked4:"",
        checked5:"",
        checked6:"",
        checked7:"",
        checked8:"",
        checked9:"",
        checked10:"",
        checked11:"",
      };
    },
    //时间转换
    dates(){
      this.data.startDate = '';
      this.data.endDate = '';
      if(this.startDate != null && this.startDate != ''){
        let d = this.startDate;//开始时间
        let startDate = new Date(d).getTime()/1000;
        startDate = Number(startDate).toFixed(0);
        this.data.startDate = startDate;
      }
      if(this.endDate != null && this.endDate != ''){
        let d = this.endDate;//开始时间
        let endDate = new Date(d).getTime()/1000;
        endDate = Number(endDate).toFixed(0);
        this.data.endDate = endDate;
      }
    },

    //搜索
    searchs(){
      this.change(1);
    },
    // 树组件点击触发
    nodeClick(data) {
      let project = data.tree[0];
      this.project_id = project.pindex_id;
      let tree_str=data.tree.map(ret=>{return ret.name}).join('->');
      //console.log(data.tree)
      this.data.pid = data.tree[0]['id'];
      this.data.homeName=tree_str;
      // this.change(1);
      this.data.house_id = '';
      this.search=tree_str;
      if(data.tree[data.tree.length-1].type==='room'){
        this.data.house_id = data.tree[data.tree.length-1].id;
      }
      this.house = tree_str;
      if(this.seup == 1){
        this.change(1);
      }else{
        this.setup_list.name_type = this.name_type;
        this.son_user(tree_str);
      }
    },
    //调用子组件的方法加载用户
    son_user(tree_str){
      if(this.seup == 2){
        if(this.activeName == 'currency'){
          this.$refs.currency_child.getTreeUser(tree_str)
        }
        if(this.activeName == 'average'){
          this.$refs.average_child.getTreeUser(tree_str)
        }
        if(this.activeName == 'area'){
          this.$refs.area_child.getTreeUser(tree_str)
        }
        if(this.activeName == 'consumption'){
          this.$refs.consumption_child.getTreeUser(tree_str)
        }
        if(this.activeName == 'floor'){
          this.$refs.floor_child.getTreeUser(tree_str)
        }
      }
    },
  },
  watch:{
    "search"(e){
      let _this = this;
      _this.data.homeName=e;
      let list = _this.selectList;
      list.map(function(it){
        if(e == it.house){
          _this.data.house_id = it.id;
        }
      })
    }
  },
  components: {
    "erp-tree": () => import('../../Common/erp-tree.vue'),
    "room-user": () => import('../../Common/room-user.vue'),
    "share-currency": () => import('./common/currency.vue'),
    "share-average": () => import('./common/average.vue'),
    "share-area": () => import('./common/area.vue'),
    "share-consumption": () => import('./common/consumption.vue'),
    "share-floor": () => import('./common/floor.vue')
  },

}
</script>
<style scoped>
@import '../../../../assets/css/table.css';
.ti{
  margin: 1%;
  width: 98%;
}
.text1{
  text-align: center;
}
.pages{
  margin-top: 2%;
  margin-right: 3%;
  text-align: right;
}
.search{
  margin-top: 0.2%;
  width: 20%;
  margin-bottom: 1.5%;
}
.text2{
  color: rgb(250, 248, 248);
}
.kuan{
  width: 10%;
}
.zhanwu{
  text-align: center;
  color: rgb(207, 205, 205);
  font-size: 20px;
  margin-top: 3%;
}
.cdj_margin{
  margin-left:1px;
}

.d-flex {
  display: flex;
}

.d-flex-left {
  margin-right: 10px;
  border-right: 1px solid #eee;
  padding-right: 10px;
}

.d-flex-right {
  flex: 1;
  overflow-x:hidden;
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/Project/share/ShareSetUp.vue